export const pathname = "/search";

export const page = {
  route(query: QueryParameters<{ value?: string }>) {
    return {
      asPath: `${pathname}/${query.value ?? ""}`,
      pathname,
      query: { ...query, pageType: "search" },
    };
  },
};
